export default "__VITE_ASSET__DPodPG7t__"